import EatingHeader from './EatingHeader';

export default EatingHeader;
